import { defineComponent as _defineComponent } from 'vue'
import { deliverGoods } from '@/api/order/order-list';
import ModalItem from '@/component/ModalItem/ModalItem.vue';
import { useForm } from '@/util/useForm';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderOperation',
  props: {
    record: null
  },
  emits: ['ok'],
  setup(__props: any, { emit }) {

const props = __props as {
  record: any;
};



const form = useForm({ name: 'dynamic_form_item' });
let count = 1;
onMounted(() => {
  form.value.getFieldDecorator('keys', { initialValue: [0], preserve: true });
});
function addParcel() {
  const keys = form.value.getFieldValue('keys');
  const nextKeys = keys.concat(count++);
  form.value.setFieldsValue({
    keys: nextKeys,
  });
}
function onClose(){
  form.value.resetFields()
}
function minusParcel(k) {
  const keys = form.value.getFieldValue('keys');
  if (keys.length === 1) {
    return;
  }
  form.value.setFieldsValue({
    keys: keys.filter(key => key !== k),
  });
}
async function onShipments(onloading, cal) {
  form.value.validateFields((err, values) => {
    if (!err) {
      const { keys, company, number } = values;
      const list = keys.map(key => {
        return {
          company: company[key],
          number: number[key],
        };
      });
      console.log(list);
      onloading?.();
      deliverGoods(props.record.order_id, list).then(res => {
        onloading?.();
        if (res) {
          cal?.();
          emit('ok');
        }
      });
    }
  });
  //
  // cal?.();
}

return { __sfc: true,props, emit, form, count, addParcel, onClose, minusParcel, onShipments, ModalItem }
}

})